import type { GoalPortfolioResponseDTO } from "web_myplann/Infrastructure/Api/Api";

export const getUncoveredOwnFunds = (
	ownFunds: number,
	portfolios: GoalPortfolioResponseDTO[],
): number => {
	const pinnedValue = portfolios.reduce(
		(sum, portfolio) => sum + (portfolio.portfolioValue ?? 0),
		0,
	);

	return Math.max(0, ownFunds - pinnedValue);
};
